import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls whether or not we show orders in global nav
 */
export const ORDERS_IN_GLOBAL_NAV_250303 =
  'ORDERS_IN_GLOBAL_NAV_250303' as SettingConst<
    'ORDERS_IN_GLOBAL_NAV_250303',
    boolean,
    'RETAILER' | 'RETAILER_HEAD_TAGS' | 'VISITOR_WEB' | 'VISITOR_WEB_HEAD_TAGS'
  >;
